export type ResponsibilityRole = 'teacher' | 'student' | 'guardian';

export function resolveResponsibilityConfirmDelaySeconds(
  deployEnvironment: string,
): number {
  return deployEnvironment === 'production' ? 10 : 1;
}

export const responsibilityConfirmDelaySeconds =
  resolveResponsibilityConfirmDelaySeconds(
    import.meta.env.VITE_DEPLOY_ENV ?? import.meta.env.MODE,
  );

const teacherRoles = new Set([
  'teacher',
  'subject_teacher',
  'head_teacher',
  'advisor',
]);

export function responsibilityRoles(
  roles: readonly string[],
): ResponsibilityRole[] {
  const result: ResponsibilityRole[] = [];
  if (roles.some((role) => teacherRoles.has(role))) result.push('teacher');
  if (roles.includes('student')) result.push('student');
  if (roles.includes('guardian')) result.push('guardian');
  return result;
}

export function responsibilityStorageKey(
  accountId: string,
  tenantId: string,
  role: ResponsibilityRole,
): string {
  return `perceptio:responsibility:${accountId}:${tenantId}:${role}:v1`;
}

export function nextResponsibilityCountdown(current: number): number {
  return Math.max(0, current - 1);
}
